import { useNavigate } from 'react-router';
import { JobListingCard } from '@tempmee/react-blocks';
import { JobPostingStatus } from '~/domain/PermanentJobs';

import { IDraftJobCardProps } from './Types';
import { getJobRoleBadgeCode, getStatusDateLabel } from './utils';

export const DraftJobCard = ({
  id,
  lastSavedAt,
  office,
  officeSelected,
  professionType,
  subProfession,
  title,
  onDeleteDraft,
}: IDraftJobCardProps) => {
  const navigate = useNavigate();

  const handleContinueClick = () => {
    navigate(`/permanent-jobs/postings/${id}/create`);
  };

  return (
    <JobListingCard
      data-cy="draft-job-card"
      status="draft"
      title={title || 'UNTITLED'}
      jobRole={getJobRoleBadgeCode(professionType, subProfession)}
      office={officeSelected ? office?.name || 'No Office Selected' : 'No Office Selected'}
      dateLabel={getStatusDateLabel(JobPostingStatus.Draft, { lastSavedAt })}
      onCardClick={handleContinueClick}
      menuButtonTestID="draft-job-card-menu"
      menuItems={[
        {
          label: 'Activate Posting',
          testID: 'draft-job-card-activate',
          onSelect: handleContinueClick,
        },
        {
          label: 'Delete',
          testID: 'draft-job-card-delete',
          onSelect: () => onDeleteDraft?.(id),
        },
      ]}
    />
  );
};
